module.exports = __webpack_public_path__ + "media/categories/power-770de3d4.png";